import { FichaListaHomeContent } from './../model/ficha-lista-home-content.interface';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-lista-ficha-home-status',
  templateUrl: './lista-ficha-home-status.component.html',
})
export class ListaFichaHomeStatusComponent {

  @Input() propostas: FichaListaHomeContent[] = [];
  @Input() idFase: number;
  @Output() emitOrdenacao = new EventEmitter<any>();
}
